export const getPromoModalVisible = state => state.promoModalVisible
export const getPromoCurrent = state => state.promoCurrent
